import { call, put, select } from "redux-saga/effects";
import api from "../../services/api";
import history from "../../services/history";
import { Creators as CouponActions } from "../ducks/coupon";

//função de pedido chamada
export function* getCoupon({ payload }) {
    const { profile } = yield select(state => state.user);
  try {
    const { data } = yield call(api.post, `/coupons/validateCoupon`, {
        clienteUuid: profile.uuid,
        coupon: payload.data.cupom,
        orderValue: payload.data.amount,
        shippingValue: payload.data.valorFrete,
        basket: payload.data.carrinho.itens.map(item => item.id),
        cartId: payload.data.carrinho.carrinhoId,
        deliveryType: payload.data.tipoEntrega,
        paymentDiscount: payload.data.percDescontoPagamento,
        storeId: payload.data.storeId,
      });
      
      if (data.error !== undefined) {        
        yield put(CouponActions.getCouponFailure(data.error));
        return;
      } else {
        yield put(CouponActions.getCouponSuccess(data));
        return;
      }
  } catch (error) {
    window.scrollTo(0, 0);
    history.push("/checkout/pagamento");
    yield put(CouponActions.getCouponFailure(error));
  }
}

